export const localization = {
  en: {
    switchPatient: 'SWITCH PATIENT',
    modalTitle: 'View Dependent Accounts',
    DOB: 'DOB',
    self: '(Self)'
  },
  es: {
    switchPatient: 'CAMBIAR DE PACIENTE',
    modalTitle: 'Ver cuentas de dependientes',
    DOB: 'Fecha de nacimiento',
    self: '(Yo mismo)'
  },
  keyMapping: {
    switchPatient: 'UFD_Switch_Patient_Button',
    modalTitle: 'UFD_Switch_Patient_Title',
    DOB: 'UFD_Switch_Patient_DOB',
    self: 'UFD_Switch_Patient_Self'
  }
}

export default localization
